<template>
  <div id="tab_tracking" class="tab-pane fade in active">
    <div class="tab__header">Tracking Sheet</div>
    <Comparisons></Comparisons>
    <div class="tab__sub-header">High-Level Performance Tracking</div>
    <div class="kpi__table-container">
      <table class="kpi-table">
        <tr class="kpi-table__header">
          <th colspan="2">High-Level Performance Tracking</th>
          <th class="target">Monthly</th>
          <th v-for="months in monthAbbreviations">{{ months }}</th>
          <th colspan="3">YTD</th>
        </tr>
        <tr class="kpi-table__header">
          <th colspan="2">Description</th>
          <th class="target">Target</th>
          <th v-for="months in monthAbbreviations">Actual</th>
          <th>Target</th>
          <th>Actual</th>
          <th>Variance</th>
        </tr>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsHighLevelPerformance" :index="index" :key="`row-high-level-${index}`" :metric="metric"></component>
      </table>
    </div>
    <div class="legend"><span class="legend__key kpi-performance-table__month--selected"></span> = Selected Month</div>
    <div class="tab__sub-header">Key Performance Indicators</div>
    <div class="kpi__table-container">
      <table class="kpi-table">
        <tr class="kpi-table__header">
          <th colspan="2">Key Performance Indicators</th>
          <th class="target">Monthly</th>
          <th v-for="months in monthAbbreviations">{{ months }}</th>
          <th colspan="3">YTD</th>
        </tr>
        <tr class="kpi-table__header">
          <th colspan="2">Description</th>
          <th class="target">Target</th>
          <th v-for="months in monthAbbreviations">Actual</th>
          <th>Target</th>
          <th>Actual</th>
          <th>Variance</th>
        </tr>
        <component v-bind:is="getComponentName(metric.field)" v-for="(metric, index) in metricsKeyIndicatorsPerformance" :index="index" :key="`row-key-indicators-${index}`" :metric="metric"></component>
      </table>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import Comparisons from './Comparisons.vue';
  import TableRowBase from './tracking-sheet/table-rows/TableRowBase.vue';
  import TableRowGrossHaRevPerGrossRev from './tracking-sheet/table-rows/TableRowGrossHaRevPerGrossRev.vue';
  import TableRowGrossMarginPerNetHaRev from './tracking-sheet/table-rows/TableRowGrossMarginPerNetHaRev.vue';
  import TableRowNetProfitPerNetHaRev from './tracking-sheet/table-rows/TableRowNetProfitPerNetHaRev.vue';
  import TableRowMarketingSpendPer from './tracking-sheet/table-rows/TableRowMarketingSpendPer.vue';
  import TableRowPayrollRelatedPerNetRev from './tracking-sheet/table-rows/TableRowPayrollRelatedPerNetRev.vue';
  import TableRowAvgDollarsDiscounted from './tracking-sheet/table-rows/TableRowAvgDollarsDiscounted.vue';
  import TableRowHaeConversionRate from './tracking-sheet/table-rows/TableRowHaeConversionRate.vue';
  import TableRowHaeToAudiogramRate from './tracking-sheet/table-rows/TableRowHaeToAudiogramRate.vue';
  import TableRowBinauralRate from './tracking-sheet/table-rows/TableRowBinauralRate.vue';
  import TableRowAvgSellingPricePreDisc from './tracking-sheet/table-rows/TableRowAvgSellingPricePreDisc.vue';
  import TableRowDiscountPer from './tracking-sheet/table-rows/TableRowDiscountPer.vue';
  import TableRowAvgSellingPricePostDisc from './tracking-sheet/table-rows/TableRowAvgSellingPricePostDisc.vue';
  import TableRowAvgPatientNetRev from './tracking-sheet/table-rows/TableRowAvgPatientNetRev.vue';
  import TableRowDollarRefundRate from './tracking-sheet/table-rows/TableRowDollarRefundRate.vue';
  import TableRowUnitRefundRate from './tracking-sheet/table-rows/TableRowUnitRefundRate.vue';
  import TableRowMarginPerUnit from './tracking-sheet/table-rows/TableRowMarginPerUnit.vue';
  import TableRowNetRevPerProvider from './tracking-sheet/table-rows/TableRowNetRevPerProvider.vue';
  import TableRowNetRevPerPhysician from './tracking-sheet/table-rows/TableRowNetRevPerPhysician.vue';

  export default {
    name: 'Tracking',
    components: {
      Comparisons,
      TableRowBase,
      TableRowGrossHaRevPerGrossRev,
      TableRowGrossMarginPerNetHaRev,
      TableRowNetProfitPerNetHaRev,
      TableRowMarketingSpendPer,
      TableRowPayrollRelatedPerNetRev,
      TableRowNetRevPerProvider,
      TableRowNetRevPerPhysician,
      TableRowHaeConversionRate,
      TableRowHaeToAudiogramRate,
      TableRowBinauralRate,
      TableRowAvgSellingPricePreDisc,
      TableRowDiscountPer,
      TableRowAvgSellingPricePostDisc,
      TableRowAvgPatientNetRev,
      TableRowDollarRefundRate,
      TableRowUnitRefundRate,
      TableRowMarginPerUnit,
      TableRowAvgDollarsDiscounted,
    },
    computed: {
      ...mapGetters('audiologyKpis', [
        'monthAbbrevs',
        'metricsHighLevelPerformance',
        'metricsKeyIndicatorsPerformance',
        'ytdCustomCalculationFields',
      ]),
      monthAbbreviations() {
        return lodash.takeRight(this.monthAbbrevs, 12);
      },
    },
    data() {
      return {
        pugTemplateName: 'TrackingSheetTableRow.pug',
      };
    },
    methods: {
      getComponentName(field) {
        if (this.ytdCustomCalculationFields.includes(field)) {
          return `TableRow${lodash.chain(field).camelCase().upperFirst().value()}`;
        }
        return 'TableRowBase';
      },
    },
  };
</script>
